<script setup>
import { useAuthStore } from "@/stores/auth";
import DefaultButton from "@/components/utils/DefaultButton.vue";

const userStore = useAuthStore();
const user = userStore.getUser;
</script>

<template>
  <div class="flex justify-center items-center bg-gray-100 dark:bg-gray-800">
    <div class="bg-white dark:bg-gray-700 rounded-lg shadow-lg p-6 w-full max-w-md mt-5">
      <h1 class="text-2xl font-bold text-gray-800 dark:text-gray-200 mb-4 text-center">
        Profile Page
      </h1>

      <div class="space-y-6">
        <!-- Name -->
        <div class="flex items-center space-x-4">
          <span class="material-icons-round text-2xl text-gray-600 dark:text-gray-400">person</span>
          <div>
            <h2 class="text-lg font-semibold text-gray-700 dark:text-gray-300">Name</h2>
            <p class="text-gray-600 dark:text-gray-400">{{ user.name }}</p>
          </div>
        </div>

        <!-- Email -->
        <div class="flex items-center space-x-4">
          <span class="material-icons-round text-2xl text-gray-600 dark:text-gray-400">email</span>
          <div>
            <h2 class="text-lg font-semibold text-gray-700 dark:text-gray-300">Email</h2>
            <p class="text-gray-600 dark:text-gray-400">{{ user.email }}</p>
          </div>
        </div>

        <!-- Phone -->
        <div class="flex items-center space-x-4">
          <span class="material-icons-round text-2xl text-gray-600 dark:text-gray-400">phone</span>
          <div>
            <h2 class="text-lg font-semibold text-gray-700 dark:text-gray-300">Phone</h2>
            <p class="text-gray-600 dark:text-gray-400">{{ user.phone }}</p>
          </div>
        </div>
      </div>

      <!-- Edit Profile Button -->
      <div class="mt-6 text-center">
        <DefaultButton title="Edit Profile"  link="/profile/edit"/>
      </div>
    </div>
  </div>
</template>

<style scoped>
/* Optional global styles */
body {
  font-family: Arial, sans-serif;
}
</style>
